import { useCallback } from 'react';
import { isNative, hapticImpact, hapticNotification } from '../utils/capacitor';

/**
 * Hook for haptic feedback on key user actions.
 * No-op on web — only vibrates on native iOS/Android.
 */
export function useHaptic() {
  const light = useCallback(() => { if (isNative) hapticImpact('Light'); }, []);
  const medium = useCallback(() => { if (isNative) hapticImpact('Medium'); }, []);
  const heavy = useCallback(() => { if (isNative) hapticImpact('Heavy'); }, []);
  const success = useCallback(() => { if (isNative) hapticNotification('Success'); }, []);
  const warning = useCallback(() => { if (isNative) hapticNotification('Warning'); }, []);
  const error = useCallback(() => { if (isNative) hapticNotification('Error'); }, []);

  return { light, medium, heavy, success, warning, error };
}
